import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export function parseDisplayDate(value) {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : dayjs(value);
  if (typeof value !== "string" || !value.trim()) return null;
  const text = value.trim();
  if (text.includes("/")) {
    const formats = ["DD/MM/YYYY", "DD/MM/YYYY HH:mm", "DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY, HH:mm", "DD/MM/YYYY, HH:mm:ss"];
    const date = dayjs(text, formats, true);
    return date.isValid() ? date : null;
  }
  if (!/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(text)) return null;
  if (!dayjs(text.slice(0, 10), "YYYY-MM-DD", true).isValid()) return null;
  const date = dayjs(text);
  return date.isValid() ? date : null;
}

export function formatBrDate(value, includeTime = false) {
  const date = parseDisplayDate(value);
  // Ano com dois digitos em todo lugar do sistema. A leitura acima continua
  // aceitando quatro, que e o que a API manda.
  return date ? date.format(includeTime ? "DD/MM/YY [às] HH:mm" : "DD/MM/YY") : "-";
}
